import { z } from 'zod'

import { recipientSchema } from '~/components/smart-accounts/schemas/recipientSchema'

export const multiRecipientSchema = z.object({
  recipients: z.array(recipientSchema).min(1),
})

export type MultiRecipientFormValues = z.input<typeof multiRecipientSchema>
